import config from '../config';

/**
 * Registra la visita de un usuario (sin email).
 * Se llama al cargar la página.
 */
export const trackVisit = (geoData = {}) => {
    const payload = {
        type: 'visit',
        ip: geoData.ip || "unknown",
        country: geoData.country || "unknown",
        region: geoData.region || "unknown",
    };
    console.log("👁️ Visit tracked:", payload);

    return fetch(config.googleScriptUrl, {
        method: "POST",
        mode: "no-cors",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
    });
};

/**
 * Suscribe al usuario al newsletter.
 * El Apps Script buscará la visita existente (mismo IP + mismo día)
 * y le agregará el email.
 */
export const subscribeToNewsletter = (email, geoData = {}) => {
    const payload = {
        type: 'subscribe',
        email,
        ip: geoData.ip || "unknown",
        country: geoData.country || "unknown",
        region: geoData.region || "unknown",
    };
    console.log("📧 Newsletter subscribe:", payload);

    return fetch(config.googleScriptUrl, {
        method: "POST",
        mode: "no-cors",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
    });
};

/**
 * Registra en el newsletter con datos extendidos para desbloquear el contenido.
 */
export const unlockContent = (email, additionalData = {}, geoData = {}) => {
    const payload = {
        type: 'unlock',
        email,
        name: additionalData.name || '',
        institution: additionalData.institution || '',
        reason: additionalData.reason || '',
        notifications: additionalData.notifications || false,
        ip: geoData.ip || "unknown",
        country: geoData.country || "unknown",
        region: geoData.region || "unknown",
    };
    console.log("🔓 Content unlock submitted:", payload);

    return fetch(config.googleScriptUrl, {
        method: "POST",
        mode: "no-cors",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
    });
};
